import { IExtendedFilterCollectionItem } from '@/interfaces/filters.interfaces';

const sortFilterCollectionItems = (
  collectionItemA: IExtendedFilterCollectionItem,
  collectionItemB: IExtendedFilterCollectionItem,
) => {
  if (
    typeof collectionItemA.position !== 'undefined' &&
    typeof collectionItemB.position === 'undefined'
  ) {
    return -1;
  }
  if (
    typeof collectionItemA.position === 'undefined' &&
    typeof collectionItemB.position !== 'undefined'
  ) {
    return 1;
  }
  if (
    (typeof collectionItemA.position === 'undefined' &&
      typeof collectionItemB.position === 'undefined') ||
    collectionItemA.position === collectionItemB.position
  ) {
    const labelA = collectionItemA.displayName.toUpperCase();
    const labelB = collectionItemB.displayName.toUpperCase();
    return labelA.localeCompare(labelB);
  }
  return (collectionItemA.position || 0) - (collectionItemB.position || 0);
};

export default sortFilterCollectionItems;
